import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Undo icon. Exported from Figma (Bombiix 2026, node 13948:419091). */
const UndoIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g transform="translate(2 2)">
      <path
        d="M4.75333 12.2067H10.0867C11.9267 12.2067 13.42 10.7133 13.42 8.87333C13.42 7.03333 11.9267 5.54 10.0867 5.54H2.75333"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.28667 7.20667L2.58 5.5L4.28667 3.79333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export default UndoIcon;
